import Button from "@/designs/Button";
import CenterModal from "@/designs/CenterModal";
import {
  GetVistorsDocument,
  useUpdateVisitorMutation,
  Visitor,
} from "@/graphql/generated/schema";
import React, { useContext } from "react";
import { CMSModal } from "@/context";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "react-i18next";

interface DeleteRowProp {
  isOpen: boolean;
  onClose: () => void;
  timeline: Visitor[] | any;
  label?: string;
}

const DeleteRow = ({ isOpen, onClose, timeline, label }: DeleteRowProp) => {
  const { theme } = useContext(CMSModal);
  const { t } = useTranslation();
  const [updateVisitor] = useUpdateVisitorMutation({
    refetchQueries: [GetVistorsDocument],
  });

  return (
    <CenterModal isOpen={isOpen} onClose={onClose}>
      <div className="space-y-4">
        <h2
          className={twMerge(
            "font-semibold transition-colors",
            theme === "dark" ? "text-gray-100" : "",
          )}
        >
          {t("visitors.deleteRow.title")} {timeline.length} {label}{" "}
          {t("visitors.deleteRow.fromList")}
        </h2>
        <p
          className={twMerge(
            "transition-colors",
            theme === "dark" ? "text-gray-400" : "text-gray-600",
          )}
        >
          {t("visitors.deleteRow.confirm")}
        </p>
        <div className="flex gap-4 items-center justify-end">
          <Button variant="outline" className="w-50" onClick={onClose}>
            {t("visitors.deleteRow.cancel")}
          </Button>
          <Button
            className="w-50"
            onClick={async () => {
              await timeline.map(async (t: Visitor) => {
                updateVisitor({
                  variables: {
                    input: {
                      _id: t.id,
                      anonymize: true,
                    },
                  },
                });
              });
              onClose();
            }}
          >
            {t("visitors.deleteRow.remove")}
          </Button>
        </div>
      </div>
    </CenterModal>
  );
};

export default DeleteRow;
